import { render, staticRenderFns } from "./NestedSorting.vue?vue&type=template&id=0d2b06ce&scoped=true"
import script from "./NestedSorting.vue?vue&type=script&lang=js"
export * from "./NestedSorting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b06ce",
  null
  
)

export default component.exports